import { useCallback, useContext } from 'react';

import { LayoutActionType } from '../constant';
import { LayoutContext } from '..';

export default function useBottomPanelLayout() {
  const context = useContext(LayoutContext);

  const dispatch = context?.dispatch || (() => {});
  const bottomPanelState = context?.layout?.bottomPanelState;

  return {
    /** Show bottom panel to normal state */
    show: useCallback(() => {
      dispatch({ type: LayoutActionType.BOTTOM_PANEL_SHOW });
    }, [dispatch]),

    /** Collapse bottom panel */
    collapse: useCallback(() => {
      dispatch({ type: LayoutActionType.BOTTOM_PANEL_COLLAPSE });
    }, [dispatch]),

    /** Show bottom panel to expanded state */
    expand: useCallback(() => {
      dispatch({ type: LayoutActionType.BOTTOM_PANEL_EXPAND });
    }, [dispatch]),

    /** @type {'expand' | 'normal' | 'collapsed'} */
    state: bottomPanelState,

    /** @type {boolean} */
    isExpand: bottomPanelState === 'expand',

    /** @type {boolean} */
    isCollapsed: bottomPanelState === 'collapsed',

    /** @type {boolean} */
    isNormal: bottomPanelState === 'normal',

    /** Refetch data of currently opened table */
    refetchTable: useCallback(() => {
      context.refs.current.bottomPanelTable?.current?.refetchTable?.();
    }, []),
  };
}
